module.exports = __webpack_public_path__ + "static/media/strong03.3af79db8.jpg";